import {useState} from "react";

export default function useExpandableRowIds() {
    const [expandedRowIds, setExpandedRowIds] = useState(new Set());

    const toggleRow = (rowId) => {
        setExpandedRowIds(previouslyExpandedRowIds => {
            const nextExpandedRowIds = new Set(previouslyExpandedRowIds);
            if (nextExpandedRowIds.has(rowId)) {
                nextExpandedRowIds.delete(rowId);
            } else {
                nextExpandedRowIds.add(rowId);
            }
            return nextExpandedRowIds;
        });
    };

    const expandAllOf = (rowIds) => setExpandedRowIds(new Set(rowIds));
    const collapseAll = () => setExpandedRowIds(new Set());

    return {expandedRowIds, toggleRow, expandAllOf, collapseAll};
}
